import {IProviderSearchResult, space} from "../../compiled";
import './MapSearch.css';
import {formatUrl} from "../../util/UrlUtil";


type Props = {
  searchResult: IProviderSearchResult
}

// This is an html string cause the maps javascript API can't do typescript
// ReactElements.
export const MapMarkerPopup = (props: Props) => {

  const imageUrl = props.searchResult.location?.physicalLocation?.imageUrl ||
      props.searchResult.businessProfile?.imageUrl;

  return `
  <div class='MapMarkerPopup'>
    <div class='MapMarkerPopupImageContainer'>
        <img class='MapMarkerPopupImage' src="${imageUrl}" alt="Office image"/>
    </div>
    <div class="MapMarkerPopupBusinessName">
        <b>${props.searchResult.businessProfile?.businessName}</b>
    </div>
    <div class="MapMarkerAddress">${props.searchResult?.location?.physicalLocation?.private ?
      '[Location hidden until booking]' :
      props.searchResult?.location?.physicalLocation?.address}
    </div>
    <div class="MapMarkerButtonRow">
      <a class="MapMarkerBookButton" target="_blank" href="${formatUrl(props.searchResult.businessProfile?.websiteUrl)}">WEBSITE</a>
      
      ${props.searchResult.businessProfile?.hasBooking ?
      `<a class="MapMarkerBookButton" target="_blank" href="/book?b=${props.searchResult.businessId}">BOOK NOW</a>` : ''}
    </div>
  </div>
</a>
`;
}